<span class="indicator" [title]="type()" [style.background-color]="color()"></span>
